import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

function isTokenValid(token: string | null): boolean {
  if (!token) return false;

  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;

    // Decode payload
    const payload = JSON.parse(atob(parts[1]));
    const exp = payload.exp; // expiration timestamp (seconds since epoch)
    const now = Math.floor(Date.now() / 1000);

    return typeof exp === 'number' && exp > now;
  } catch (e) {
    return false;
  }
}

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        router.navigate(['/login']);
        return of(false);
      }

      // Try to get the access token
      return from(authService.getAccessTokenSilently()).pipe(
        map((token) => {
          if (isTokenValid(token)) {
            return true;
          } else {
            router.navigate(['/login']);
            return false;
          }
        }),
        catchError(() => {
          router.navigate(['/login']);
          return of(false);
        })
      );
    })
  );
};